module.exports = __webpack_public_path__ + "img/COM-A-2-II.395b2d64.png";